import { DefaultService } from '@/services/DefaultService';

export default class AgroVisitaItemFotoService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

	findAll(column, order, page, limit, ...params) {
		return this._http.get(`${this._env}/agro/visitaitemfotos/attachment.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`, 
		this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	findAllByUuid(page, limit, uuid, ...params) {
		return this._http.get(`${this._env}/agro/visitaitemfotos/attachmentbyvisita.json?page=${page}&limit=${limit}&uuid=${uuid}&param=${params}`, 
		this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	save(file, attachment) {
        // Cria o formData para enviar o arquivo
        var data = new FormData();
        data.append("file", file);
        // Adiciona o objeto com os dados auxiliares do anexo.
        data.append("agrovisitaitemfoto", new Blob([JSON.stringify( attachment )],
        {
            type: "application/json"
        }));
        data.append("agrovisitaitemfoto", attachment);

        // Altera o Header para adicionar os headers necessários do multipart-data
        let requestHeader = {
            method: 'POST',
            headers: Object.assign(this._headers.headers),
            body: data
        }

        // Remove o content-type do header para forçar o navegador a inseri-los novamente, gerando corretamente o content-type necessário.
        delete requestHeader.headers["Content-Type"];

		return this._http.post(`${this._env}/agro/visitaitemfotos/attachment`, data, requestHeader).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	delete(idanexo) {
		return this._http.delete(`${this._env}/agro/visitaitemfotos/attachment/${idanexo}`, 
		this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

}